<div class="report-overview flex--column has-toolbar screen-only" data-test="report-overview">
  <mat-toolbar>
    <span class="mat-toolbar__title text--primary">
      {{ 'report-overview.reports' | translate }}
    </span>
  </mat-toolbar>
  <app-report-navigation></app-report-navigation>

  <ng-container *ngIf="cycles$ | async as cycles">
    <mat-nav-list role="list" *ngIf="cycles.length">
      <mat-accordion mat-list-item role="listitem">
        <ng-container *ngFor="let cycle of cycles">
          <mat-expansion-panel class="mat-elevation-z0" data-test="report-overview__item">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-panel-title
                (click)="printCyclePdf($event, cycle.id, cycle.concept)"
                class="report-overview__barn"
                data-test="report-overview__title"
              >
                {{ 'report-overview.cycle' | translate }} {{ cycle.cycleNumber }}
              </mat-panel-title>
              <mat-panel-description data-test="report-overview__cycleDate">
                <span>
                  {{ cycle.cycleDate | agrDate }} -
                  {{ cycle.cycleEndDate | agrDate }}
                </span>
                <span *ngIf="cycle.isFinalBalance && cycle.cycleEndDate" class="cycle-finished">{{
                  'report-overview.cycle-closed' | translate
                }}</span>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-container *ngFor="let barn of getBarnsByCycle(cycle)">
              <button
                mat-flat-button
                (click)="printBarnPdf(barn.id, cycle.id, cycle.concept)"
                class="report-overview__barn"
                data-test="report-overview__barn"
              >
                <mat-icon>attachment</mat-icon>
                {{ 'report-overview.barn-report' | translate }} {{ barn.name }}
              </button>
            </ng-container>
          </mat-expansion-panel>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-accordion>
    </mat-nav-list>

    <agr-notification-empty
      [isEmpty]="cycles && !cycles.length"
      [emptyTitle]="'no-cycles-title' | translate"
      [emptyDescription]="'no-cycles-description' | translate"
      emptyImage="assets/images/flock-cycle.jpg"
    >
    </agr-notification-empty>
  </ng-container>
</div>
<app-report-print></app-report-print>
